module.exports = __webpack_public_path__ + "img/seven7Blue.fd28e406.jpg";